import React, { useState } from 'react';
import styles from './OsiBulkUpdateModalWrapper.module.scss';
import Modal from 'antd/lib/modal/Modal';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import Input from 'antd/lib/input';
import { PlusCircleOutlined, CloseSquareOutlined } from '@ant-design/icons';
import { ThemeConfigKeys } from '../../../utils/Constants';
import { ThemeProvider } from '../../ThemeProvider';
import { ISelectedRowsObject } from '../../FiltersTableLayouts/FiltersTableLayoutsWrapperV2';
import { NotificationActions } from '../../../store/actions/notificationActions';
import { NotificationType } from '../../../views/NotificationsManager/Notification/Notification';
import { BookingCreateManagerV2TableActions } from '../../../store/actions/BookingCreateManagerV2/TableActions';

interface IOsiBulkUpdateModalProps {
  showModalWindow: boolean;
  setShowModalWindow: (val: boolean) => void;
  selectedRowsObject: ISelectedRowsObject;
  handleRowSelect: (keys: any[], rows: any[]) => void;
  getData: () => void;
}

const OsiBulkUpdateModalWrapper: React.FC<IOsiBulkUpdateModalProps> = (props) => {
  const { showModalWindow, setShowModalWindow, selectedRowsObject, handleRowSelect, getData } = props;
  const [osiText, setOsiText] = useState<string>('');
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const handleClose = () => {
    setOsiText('');
    setShowModalWindow(false);
  };

  const handleSave = async () => {
    if (!osiText.trim()) return;

    setIsSaving(true);
    try {
      const ids = selectedRowsObject.selectedRowKeys.map((key) => String(key));
      await BookingCreateManagerV2TableActions.bulkUpdateOsis(ids, [osiText]);

      // NotificationActions.addNotification({
      //   type: NotificationType.SUCCESS,
      //   message: `OSI text updated successfully.`,
      // });

      handleRowSelect([], []);
      getData();
      handleClose();
    } catch {
      NotificationActions.addNotification({
        type: NotificationType.ERROR,
        message: 'Failed to update OSI text. Please try again.',
      });
    } finally {
      setIsSaving(false);
    }
  };

  const selectedCount = selectedRowsObject.selectedRowKeys.length;

  const renderModalHeader = (): React.ReactNode => (
    <div className={styles.headerContainer}>
      <div className={styles.headerFirstLine}>
        <div className={styles.headerMainText}>
          <PlusCircleOutlined />
          &nbsp;
          {`BULK UPDATE OSI TEXT (${selectedCount} rule${selectedCount > 1 ? 's' : ''} selected)`}
        </div>
        <div className={styles.headerButtons}>
          <Space size={5}>
            <ThemeProvider themeKey={ThemeConfigKeys.DnataBlueCustomCollapseBtn}>
              <Button
                type="primary"
                className={styles.saveButton}
                disabled={!osiText.trim() || isSaving}
                loading={isSaving}
                onClick={handleSave}
              >
                Save
              </Button>
            </ThemeProvider>
            <ThemeProvider themeKey={ThemeConfigKeys.DnataBlueCloseBtn}>
              <Button
                type="primary"
                className={styles.closeButton}
                disabled={isSaving}
                onClick={handleClose}
              >
                <CloseSquareOutlined />
              </Button>
            </ThemeProvider>
          </Space>
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      open={showModalWindow}
      title={renderModalHeader()}
      className={styles.osiBulkUpdateModal}
      footer={null}
      closable={false}
      centered
      destroyOnClose
      width={500}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <span>Enter the new OSI text to apply to all selected rules:</span>
        <Input.TextArea
          rows={4}
          value={osiText}
          onChange={(e) => setOsiText(e.target.value)}
          placeholder="Enter OSI text..."
        />
      </Space>
    </Modal>
  );
};

export default OsiBulkUpdateModalWrapper;
